/**
 * Event Constants - 事件相關常數定義
 */

import type {
  EventType,
  EventPriority,
  EventLevel,
  EventSource,
  IncidentLevel,
  IncidentStatus,
  RiskType,
  RiskLevel
} from './types'

// 事件類型常數定義
export const EVENT_TYPES: Record<string, EventType> = {
  ALARM: 'alarm',
  WARNING: 'warning',
  INFO: 'info',
  SYSTEM: 'system',
  MAINTENANCE: 'maintenance',
  TEMPERATURE: 'temperature',
  CONDITION: 'condition',
  TIMEOUT: 'timeout',
  RECOVERY: 'recovery',
  OTHER: 'other',
  INCIDENT: 'incident',
  RISK: 'risk'
} as const

// 緊急事件等級
export const INCIDENT_LEVELS: Record<string, IncidentLevel> = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium'
} as const

// 緊急事件狀態
export const INCIDENT_STATUSES: Record<string, IncidentStatus> = {
  ACTIVE: 'active',
  PENDING: 'pending',
  PROCESSING: 'processing',
  RESOLVED: 'resolved'
} as const

// 風險類型
export const RISK_TYPES: Record<string, RiskType> = {
  OVERLOAD: 'overload',
  GENERATION: 'generation',
  WEATHER: 'weather',
  EQUIPMENT: 'equipment'
} as const

// 風險等級
export const RISK_LEVELS: Record<string, RiskLevel> = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
} as const

// 事件優先級
export const EVENT_PRIORITIES: Record<string, EventPriority> = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
} as const

// 事件層級
export const EVENT_LEVELS: Record<string, EventLevel> = {
  ORGANIZATION: 'organization',
  FIELD: 'field',
  SYSTEM: 'system',
  DEVICE: 'device'
} as const

// 事件來源
export const EVENT_SOURCES: Record<string, EventSource> = {
  DEVICE: 'device',
  SYSTEM: 'system',
  USER: 'user',
  MQTT: 'mqtt',
  API: 'api'
} as const
